module.exports = __webpack_public_path__ + "static/media/branding_1080p_br.73c86421.png";